import { connectionTypes, integrationEventNames, installationStates, integrationTypes } from '../static/constants';
import { IInstallation } from '../models';
import { mockHeaderData } from './mockHeader';
import { v4 } from 'uuid';

const tenantId = '7a8e7b5f-6b15-4db0-92d5-f774d230b276';
const tenantName = 'Gee Bagels';
const installationId = '1';
const userName = 'Mock User';

const installation = {
    state: installationStates.HEALTHY,
    isOnboarded: false,
    installationId,
    allowSmartLists: true,
    authorizeUrl: 'https://google.com',
    billing: {
        hasFreePlan: true,
        hasPaidPlan: false,
        hasBought: false,
        url: 'https://apps.livestage.test.xero.com/123456/nz/subscription/hubspot/add',
    },
    versionSupport: {
        canUpdate: true,
        latestVersion: 1,
        updateRequiresAuthorization: true,
    },
};

const organisation = {
    organisationBaseCurrency: 'NZD',
    organisationClass: 'STARTER',
    organisationRegion: 'NZ',
    organisationTimezone: 'Pacific/Auckland',
    organisationPaysTax: false,
};

// /header
export const header = {
    GET: mockHeaderData(userName),
};

const baseEvent = {
    eventDate: 1541104907514,
    eventName: integrationEventNames.CONTACT_SENT,
    contactName: tenantName,
    userName: 'Zach Smith',
};

const contactSyncSettings = [
    {
        type: 'Customer',
        isSyncEnabled: true,
    },
    {
        type: 'Supplier',
        isSyncEnabled: true,
    },
    {
        type: 'Other',
        isSyncEnabled: true,
    },
];

const smartLists = [
    {
        name: 'Have purchased an item',
        id: 'some-random-guid-1',
        selected: true,
    },
    {
        name: 'Outstanding > 30 days',
        id: 'some-random-guid-2',
        selected: true,
    },
    {
        name: 'Overdue > 7 days',
        id: 'some-random-guid-3',
        selected: false,
    },
    {
        name: 'Paid us (in the last year)',
        id: 'some-random-guid-4',
        selected: true,
    },
];

// /bootstrap
export const bootstrap = {
    // /bootstrap/CUSTOM
    CUSTOM: {
        GET: {
            ...organisation,
            tenantId,
            installation: {
                ...installation,
                integrationType: integrationTypes.CUSTOM,
                state: installationStates.CONNECTION_REQUIRED,
                connectionType: connectionTypes.CUSTOM,
                isOnboarded: false,
                billing: {
                    hasFreePlan: false,
                    hasPaidPlan: true,
                    hasBought: false,
                    url: 'https://apps.livestage.test.xero.com/123456/nz/subscription/hubspot/add',
                },
            } as IInstallation,
            // error: {
            //     code: 403,
            //     body: {
            //         isAdmin: true,
            //         hasRequiredPlan: false,
            //     },
            // },
        },
    },
    // /bootstrap/HUBSPOT
    HUBSPOT: {
        GET: {
            ...organisation,
            tenantId,
            installation: {
                ...installation,
                integrationType: integrationTypes.HUBSPOT,
                state: installationStates.CONNECTION_REQUIRED,
                connectionType: connectionTypes.OAUTH2,
                isOnboarded: false,
                billing: {
                    hasFreePlan: true,
                    hasPaidPlan: true,
                    hasBought: true,
                    url: 'https://apps.livestage.test.xero.com/123456/nz/subscription/hubspot/add',
                },
            } as IInstallation,
            // error: {
            //     code: 403,
            //     body: {
            //         isAdmin: true,
            //         hasRequiredPlan: false,
            //     },
            // },
        },
    },
    // /bootstrap/SHOPIFY
    SHOPIFY: {
        GET: {
            tenantId,
            installation: {
                ...installation,
                integrationType: integrationTypes.SHOPIFY,
                state: installationStates.HEALTHY,
                connectionType: connectionTypes.OAUTH2,
                isOnboarded: true,
                authorizeUrl: 'https://%s',
                billing: {
                    hasFreePlan: false,
                    hasPaidPlan: true,
                    hasBought: true,
                    url: 'https://apps.livestage.test.xero.com/123456/nz/subscription/hubspot/add',
                    subscriptionEndDate: '2023-08-05T00:00:00+00:00',
                    nextBillingDate: '2023-08-05T00:00:00+00:00',
                    manageSubscriptionUrl: 'www.google.com',
                },
                freeTrial: {
                    isEligibleForTrial: false,
                    freeTrialDurationDays: 30,
                    // freeTrialEndDateUtc: '2023-08-05T00:00:00',
                    // freeTrialRemainingDays: 30,
                },
                versionSupport: {
                    canUpdate: false,
                    latestVersion: 2,
                    updateRequiresAuthorization: true,
                    currentVersion: 2,
                },
            } as IInstallation,
        },
    },
};

// integrations
export const integrations = {
    HUBSPOT: {
        installations: {
            POST: {},
            1: {
                GET: {},
                DELETE: {},
                connection: {
                    POST: {},
                },
                settings: {
                    GET: {
                        installationId,
                        tenantId,
                        contactSyncSettings,
                        smartLists,
                    },
                    POST: {
                        installationId,
                        tenantId,
                        contactSyncSettings,
                        smartLists,
                    },
                    PUT: {},
                },
            },
        },
    },
    SHOPIFY: {
        installations: {
            POST: {},
            1: {
                GET: {},
                DELETE: {},
                connection: {
                    POST: {},
                },
                settings: {
                    GET: {
                        shop: 'xerodev.myshopify.com',
                        contactId: 'contact-id',
                        bankAccounts: [
                            {
                                accountId: v4(),
                                bankAccountNumber: '12-121232131-00',
                                name: 'Bank account',
                            },
                            {
                                accountId: v4(),
                                bankAccountNumber: '12-121232131-99',
                                name: 'Clearing account',
                            },
                        ],
                        chartOfAccounts: [
                            {
                                accountId: 'ac998ebb-6d44-4518-bc04-7c7ebadeab46',
                                code: '204',
                                name: 'Shopify refunds',
                                description: 'Shopify refunds account',
                                bankAccountNumber: null,
                            },
                            {
                                accountId: '6855612d-5d22-4077-aa95-501962382f7c',
                                code: '202',
                                name: 'Shopify discounts',
                                description: 'Shopify discounts account',
                                bankAccountNumber: null,
                            },
                            {
                                accountId: 'ad80058a-c1c3-44c5-a0cd-f269e46ec34a',
                                code: '203',
                                name: 'Shopify shipping',
                                description: 'Shopify shipping account',
                                bankAccountNumber: null,
                            },
                            {
                                accountId: 'fe826e1d-938a-4ca1-864f-b3934a9d5070',
                                code: '306',
                                name: 'Revenue account 3',
                                description: 'Do you like it?',
                                bankAccountNumber: null,
                            },
                            {
                                accountId: '0890afd9-5cff-4042-a1af-2d39e0986bad',
                                code: '201',
                                name: 'Shopify sales',
                                description: 'Shopify sales account',
                                bankAccountNumber: null,
                            },
                            {
                                accountId: 'ec118066-cfe0-46db-9739-06d71d47f3bd',
                                code: '307',
                                name: 'Revenue account 4',
                                description: 'Do you like it?',
                                bankAccountNumber: null,
                            },
                            {
                                accountId: 'ff60309d-6800-4fc1-a48b-339ba5b93eee',
                                code: '305',
                                name: 'Revenue account 2',
                                description: 'Do you like it?',
                                bankAccountNumber: null,
                            },
                            {
                                accountId: 'dd3741c4-bdcd-4bad-8771-14fc1e937750',
                                code: '304',
                                name: 'Revenue account 1',
                                description: 'Do you like it?',
                                bankAccountNumber: null,
                            },
                            {
                                accountId: 'c8a71ed4-52db-4c06-a213-4fb4e414b0ab',
                                code: '302',
                                name: 'Some expense account',
                                description: 'Do you like it?',
                                bankAccountNumber: null,
                            },
                            {
                                accountId: 'e6f6f61f-ab90-41de-800e-39c126fc1b33',
                                code: '308',
                                name: 'Shopify fees',
                                description: 'Shopify fees account',
                                bankAccountNumber: null,
                            },
                            {
                                accountId: '9d7d8b16-ff72-4deb-8291-988f6a35defd',
                                code: '303',
                                name: 'Some Other expense account',
                                description: 'Do you like it?',
                                bankAccountNumber: null,
                            },
                            {
                                accountId: 'b05ca3fd-560a-44da-abf7-ef9a197f3322',
                                code: '300',
                                name: 'Some current liability account',
                                description: 'Do you like it?',
                                bankAccountNumber: null,
                            },
                            {
                                accountId: 'c9d179bb-5b30-4327-90b9-e4928b39d092',
                                code: '309',
                                name: 'Shopify tax collected',
                                description: 'Shopify tax collected account',
                                bankAccountNumber: null,
                            },
                            {
                                accountId: 'c779820f-35a1-4a00-bfc5-2be416379e9e',
                                code: '310',
                                name: 'Shopify gift cards',
                                description: 'Shopify gift cards account',
                                bankAccountNumber: null,
                            },
                            {
                                accountId: 'cb25c46d-7fed-4a8d-93c9-7aff4776c608',
                                code: '301',
                                name: 'Some Other current liability account',
                                description: 'Do you like it?',
                                bankAccountNumber: null,
                            },
                        ],
                        chartOfAccountsSettings: [
                            {
                                selectedAccountId: '0890afd9-5cff-4042-a1af-2d39e0986bad',
                                accountSettingType: 0,
                                eligibleAccounts: [
                                    'ac998ebb-6d44-4518-bc04-7c7ebadeab46',
                                    '6855612d-5d22-4077-aa95-501962382f7c',
                                    'ad80058a-c1c3-44c5-a0cd-f269e46ec34a',
                                    'fe826e1d-938a-4ca1-864f-b3934a9d5070',
                                    '0890afd9-5cff-4042-a1af-2d39e0986bad',
                                    'ec118066-cfe0-46db-9739-06d71d47f3bd',
                                    'ff60309d-6800-4fc1-a48b-339ba5b93eee',
                                    'dd3741c4-bdcd-4bad-8771-14fc1e937750',
                                ],
                                defaultToSuggestion: false,
                                suggestedAccount: {
                                    accountId: '0890afd9-5cff-4042-a1af-2d39e0986bad',
                                    code: '201',
                                    name: 'Shopify sales',
                                    description: 'Shopify sales account',
                                    bankAccountNumber: null,
                                },
                                errorType: 0,
                            },
                            {
                                selectedAccountId: '6855612d-5d22-4077-aa95-501962382f7c',
                                accountSettingType: 1,
                                eligibleAccounts: [
                                    'ac998ebb-6d44-4518-bc04-7c7ebadeab46',
                                    '6855612d-5d22-4077-aa95-501962382f7c',
                                    'ad80058a-c1c3-44c5-a0cd-f269e46ec34a',
                                    'fe826e1d-938a-4ca1-864f-b3934a9d5070',
                                    '0890afd9-5cff-4042-a1af-2d39e0986bad',
                                    'ec118066-cfe0-46db-9739-06d71d47f3bd',
                                    'ff60309d-6800-4fc1-a48b-339ba5b93eee',
                                    'dd3741c4-bdcd-4bad-8771-14fc1e937750',
                                ],
                                defaultToSuggestion: false,
                                suggestedAccount: {
                                    accountId: '6855612d-5d22-4077-aa95-501962382f7c',
                                    code: '202',
                                    name: 'Shopify discounts',
                                    description: 'Shopify discounts account',
                                    bankAccountNumber: null,
                                },
                                errorType: 0,
                            },
                            {
                                selectedAccountId: 'ad80058a-c1c3-44c5-a0cd-f269e46ec34a',
                                accountSettingType: 2,
                                eligibleAccounts: [
                                    'ac998ebb-6d44-4518-bc04-7c7ebadeab46',
                                    '6855612d-5d22-4077-aa95-501962382f7c',
                                    'ad80058a-c1c3-44c5-a0cd-f269e46ec34a',
                                    'fe826e1d-938a-4ca1-864f-b3934a9d5070',
                                    '0890afd9-5cff-4042-a1af-2d39e0986bad',
                                    'ec118066-cfe0-46db-9739-06d71d47f3bd',
                                    'ff60309d-6800-4fc1-a48b-339ba5b93eee',
                                    'dd3741c4-bdcd-4bad-8771-14fc1e937750',
                                ],
                                defaultToSuggestion: false,
                                suggestedAccount: {
                                    accountId: 'ad80058a-c1c3-44c5-a0cd-f269e46ec34a',
                                    code: '203',
                                    name: 'Shopify shipping',
                                    description: 'Shopify shipping account',
                                    bankAccountNumber: null,
                                },
                                errorType: 0,
                            },
                            {
                                selectedAccountId: 'ac998ebb-6d44-4518-bc04-7c7ebadeab46',
                                accountSettingType: 3,
                                eligibleAccounts: [
                                    'ac998ebb-6d44-4518-bc04-7c7ebadeab46',
                                    '6855612d-5d22-4077-aa95-501962382f7c',
                                    'ad80058a-c1c3-44c5-a0cd-f269e46ec34a',
                                    'fe826e1d-938a-4ca1-864f-b3934a9d5070',
                                    '0890afd9-5cff-4042-a1af-2d39e0986bad',
                                    'ec118066-cfe0-46db-9739-06d71d47f3bd',
                                    'ff60309d-6800-4fc1-a48b-339ba5b93eee',
                                    'dd3741c4-bdcd-4bad-8771-14fc1e937750',
                                ],
                                defaultToSuggestion: false,
                                suggestedAccount: {
                                    accountId: 'ac998ebb-6d44-4518-bc04-7c7ebadeab46',
                                    code: '204',
                                    name: 'Shopify refunds',
                                    description: 'Shopify refunds account',
                                    bankAccountNumber: null,
                                },
                                errorType: 0,
                            },
                            {
                                selectedAccountId: 'e6f6f61f-ab90-41de-800e-39c126fc1b33',
                                accountSettingType: 4,
                                eligibleAccounts: [
                                    'c8a71ed4-52db-4c06-a213-4fb4e414b0ab',
                                    'e6f6f61f-ab90-41de-800e-39c126fc1b33',
                                    '9d7d8b16-ff72-4deb-8291-988f6a35defd',
                                ],
                                defaultToSuggestion: false,
                                suggestedAccount: {
                                    accountId: 'e6f6f61f-ab90-41de-800e-39c126fc1b33',
                                    code: '308',
                                    name: 'Shopify fees',
                                    description: 'Shopify fees account',
                                    bankAccountNumber: null,
                                },
                                errorType: 0,
                            },
                            {
                                selectedAccountId: 'c9d179bb-5b30-4327-90b9-e4928b39d092',
                                accountSettingType: 5,
                                eligibleAccounts: [
                                    'b05ca3fd-560a-44da-abf7-ef9a197f3322',
                                    'c9d179bb-5b30-4327-90b9-e4928b39d092',
                                    'c779820f-35a1-4a00-bfc5-2be416379e9e',
                                    'cb25c46d-7fed-4a8d-93c9-7aff4776c608',
                                ],
                                defaultToSuggestion: false,
                                suggestedAccount: {
                                    accountId: 'c9d179bb-5b30-4327-90b9-e4928b39d092',
                                    code: '309',
                                    name: 'Shopify tax collected',
                                    description: 'Shopify tax collected account',
                                    bankAccountNumber: null,
                                },
                                errorType: 0,
                            },
                            {
                                selectedAccountId: 'c779820f-35a1-4a00-bfc5-2be416379e9e',
                                accountSettingType: 6,
                                eligibleAccounts: [
                                    'b05ca3fd-560a-44da-abf7-ef9a197f3322',
                                    'c9d179bb-5b30-4327-90b9-e4928b39d092',
                                    'c779820f-35a1-4a00-bfc5-2be416379e9e',
                                    'cb25c46d-7fed-4a8d-93c9-7aff4776c608',
                                ],
                                defaultToSuggestion: false,
                                suggestedAccount: {
                                    accountId: 'c779820f-35a1-4a00-bfc5-2be416379e9e',
                                    code: '310',
                                    name: 'Shopify gift cards',
                                    description: 'Shopify gift cards account',
                                    bankAccountNumber: null,
                                },
                                errorType: 0,
                            },
                        ],
                        installationId,
                        paymentGateways: [
                            {
                                code: 'string',
                                name: 'string',
                                used: true,
                                isPopular: true,
                            },
                            {
                                code: 'shopify_pay',
                                name: 'Shopify pay',
                                used: true,
                                isPopular: true,
                            },
                            {
                                code: 'amazon_pay',
                                name: 'Amazon pay',
                                used: true,
                                isPopular: true,
                            },
                        ],
                        paymentGatewayDetails: {
                            shopify_pay: {
                                createInvoice: true,
                            },
                        },
                        xeroRegion: 'NZ',
                        xeroRevenueTaxRates: [
                            {
                                name: '15% GST on Income',
                                taxType: 'OUTPUT2',
                                displayTaxRate: 15,
                                taxComponents: [
                                    {
                                        name: 'GST',
                                        rate: '15.0000',
                                    },
                                ],
                            },
                            {
                                name: 'Hailun Oakdale Sales Tax',
                                taxType: 'TAX007',
                                displayTaxRate: 8.125,
                                taxComponents: [
                                    {
                                        name: 'Local Sales Tax',
                                        rate: '0.6250',
                                    },
                                    {
                                        name: 'State Tax',
                                        rate: '7.5000',
                                    },
                                ],
                            },
                        ],
                        shopifyRegions: [
                            {
                                code: 'AU',
                                name: 'Australia',
                            },
                            {
                                code: 'NZ',
                                name: 'New Zealand',
                            },
                            {
                                code: 'UK',
                                name: 'United Kingdom',
                            },
                        ],
                        supportsTaxCollection: true,
                    },
                    PUT: {},
                },
                POST: {},
                PUT: {
                    shopUrl: 'cheesecake',
                    bankAccount: {
                        accountId: v4(),
                        bankAccountNumber: '12-121232131-00',
                    },
                    clearingAccount: '',
                    installationId,
                },
            },
        },
    },
};

// /events
export const events = {
    // /events/HUBSPOT
    HUBSPOT: {
        // /events/HUBSPOT/installations/{installationId}
        installations: {
            1: {
                GET: [
                    {
                        ...baseEvent,
                        eventName: integrationEventNames.ERROR_CONNECTION,
                    },
                    baseEvent,
                    baseEvent,
                    {
                        ...baseEvent,
                        eventName: integrationEventNames.INTEGRATION_CONNECTED,
                    },
                ],
            },
            POST: {},
        },
    },
    // /events/SHOPIFY
    SHOPIFY: {
        // /events/SHOPIFY/installations/{installationId}
        installations: {
            1: {
                GET: [
                    {
                        ...baseEvent,
                        eventName: integrationEventNames.INTEGRATION_CONNECTED,
                    },
                ],
            },
            POST: {},
        },
    },
};

// /organisations
export const organisations = {
    SHOPIFY: {
        GET: [
            {
                name: tenantName,
                legalName: tenantName,
                id: tenantId,
                userIsAdmin: true,
                paysTax: false,
            },
            {
                name: 'Gee Vandalay Industries',
                legalName: 'Georges lie',
                id: '691a7deb-c35b-4b0e-b207-7d120efc2756',
                userIsAdmin: true,
                paysTax: false,
            },
            {
                name: 'No admin org & tax registered',
                legalName: 'No admin org & tax registered',
                id: '691a7deb-c35b-4b0e-b207-7d120efc2757',
                userIsAdmin: false,
                paysTax: true,
            },
            {
                name: 'admin org & tax registered',
                legalName: 'admin org & tax registered',
                id: '691a7deb-c35b-4b0e-b207-7d120efc2758',
                userIsAdmin: true,
                paysTax: true,
            },
            {
                name: 'no admin org & not tax registered',
                legalName: 'no admin org & not tax registered',
                id: '691a7deb-c35b-4b0e-b207-7d120efc2759',
                userIsAdmin: false,
                paysTax: false,
            },
        ],
    },
};

export const freeTrials = {
    SHOPIFY: {
        PUT: {},
    },
};
